import React from 'react';
import One from '../components/One';
import Two from '../components/Two';
import Three from '../components/Three';
import Box from '../components/Box';
import Shower from '../components/Shower';
import Footer from '../components/Footer';
import FAQ from '../components/FAQ';
import Four from '../components/Four';
import Five from '../components/Five';
import Service_list_com from '../components/Service_list_com';
import Contact_Form from '../components/Contact_Form';
import FeedbackList from '../components/FeedbackList';
import OfferImage from '../components/OfferImage';
import Six from '../components/Six';

function Home() {
	return (
		<div>
			<OfferImage />
			<One />
			<Two />
			<Three />
			<Service_list_com />
			<Four />
			<Six />
			<Five />
			<FeedbackList />
			<Contact_Form />
			<Box />
			<FAQ />
			<Shower />
			<Footer />
		</div>
	);
}

export default Home;
